import { render, staticRenderFns } from "./employment-contract-view-user.vue?vue&type=template&id=b2dc09ae"
import script from "./employment-contract-view-user.vue?vue&type=script&lang=js"
export * from "./employment-contract-view-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports